"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskFeedCircle = void 0;
const react_1 = __importDefault(require("react"));
const TaskFeedCircle = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("circle", { cx: "25", cy: "25", r: "24.5", stroke: color || '#25CFBB' }),
        react_1.default.createElement("rect", { x: "27.416", y: "26.3394", width: "10.5837", height: "10.6608", rx: "3.1965", fill: color || '#25CFBB' }),
        react_1.default.createElement("rect", { x: "27.416", y: "12", width: "10.5837", height: "10.6608", rx: "3.1965", fill: color || '#25CFBB' }),
        react_1.default.createElement("rect", { x: "13", y: "12", width: "10.5837", height: "10.6608", rx: "3.1965", fill: color || '#25CFBB' }),
        react_1.default.createElement("rect", { x: "13", y: "26.3394", width: "10.5837", height: "10.6608", rx: "3.1965", fill: color || '#25CFBB' })));
};
exports.TaskFeedCircle = TaskFeedCircle;
